import { categories } from "@/mocks/categories";

export default function ProductCategories() {
  return (
    <section className="w-full bg-background-100 px-6 md:px-10 py-16 md:py-24">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-900">
            Product Categories
          </h2>
          <p className="mt-2 text-sm text-foreground-500 max-w-md">
            Explore all 14 categories in the{" "}
            <strong>pandabuyspreadsheet</strong> directory
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat, idx) => (
            <a
              key={cat.slug}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group bg-background-50 rounded-2xl overflow-hidden transition-all duration-300 hover:bg-background-50/80 cursor-pointer"
            >
              <div className="h-48 overflow-hidden">
                <img
                  src={cat.image}
                  alt={`${cat.name} pandabuyspreadsheet`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <h3 className="text-base text-foreground-900">{cat.name}</h3>
                <p className="mt-1 text-xs text-foreground-500">
                  Curated <strong>pandabuyspreadsheet</strong> {cat.name.toLowerCase()} finds
                </p>
                <div className="mt-4">
                  <span
                    className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-xs whitespace-nowrap transition-all duration-300 ${
                      idx % 3 === 0
                        ? "bg-primary-500 text-background-50 group-hover:bg-primary-600"
                        : "border border-foreground-200 text-foreground-700 group-hover:border-foreground-400 group-hover:text-foreground-900"
                    }`}
                  >
                    View {cat.name}
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}